import { render, staticRenderFns } from "./FacialDevicePage.vue?vue&type=template&id=1cc10c5f&scoped=true&"
import script from "./FacialDevicePage.vue?vue&type=script&lang=js&"
export * from "./FacialDevicePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc10c5f",
  null
  
)

export default component.exports